import React from 'react'
import Laptops from '../../body/coursepix/laptop.png'
import './laptop.css'

const Laptop = () => {
  return (
    <div className='lap'>
      <img className='lappy' src={Laptops} alt="" />
    </div>
  )
}

export default Laptop
